import './index.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import RegionPage from './components/RegionPage';

import { BlogList, BlogPost } from './components/Blog';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';

// Wrapper to extract slug param for BlogPost
const BlogPostWrapper = () => {
  const { slug } = useParams();
  return <BlogPost slug={slug} />;
};

// Wrapper to extract regionKey for RegionPage
const RegionWrapper = ({ regionKey }) => {
  return <RegionPage regionKey={regionKey} />;
};

// Secondary pages sit below the fixed navbar
const Page = ({ children }) => <div className="pt-20">{children}</div>;

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        {/* Single-page site: every core section lives on the home page */}
        <Route index element={<Home />} />
        <Route path="about" element={<Navigate to="/#about" replace />} />
        <Route path="services" element={<Navigate to="/#services" replace />} />
        <Route path="resume" element={<Navigate to="/#resume" replace />} />
        <Route path="work" element={<Navigate to="/#work" replace />} />

        {/* Blog articles keep their own URLs */}
        <Route path="blog" element={<Page><BlogList /></Page>} />
        <Route path="blog/:slug" element={<Page><BlogPostWrapper /></Page>} />

        {/* Regional SEO landing pages */}
        <Route path="dubai-cto" element={<Page><RegionWrapper regionKey="dubai" /></Page>} />
        <Route path="uae-software-developer" element={<Page><RegionWrapper regionKey="uae" /></Page>} />
        <Route path="saudi-arabia-ai-developer" element={<Page><RegionWrapper regionKey="saudi-arabia" /></Page>} />
        <Route path="pakistan-software-engineer" element={<Page><RegionWrapper regionKey="pakistan" /></Page>} />
      </Routes>
    </>
  );
}

export default App;
